import React, {useEffect, useState} from 'react'
import { Button } from 'react-bootstrap'
import ReactGA from "react-ga";
const page = window.location.pathname // Obtiene la página actual
const NavbarUi = () => {
  useEffect(() => {
    ReactGA.initialize('G-0FEQG8PQKQ');
    ReactGA.pageview(window.location.pathname);
  }, []);
  const handleClick = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Navbar'
    });
  }
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  return (
    <>
      <div className='px-1 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 z-51'>
        <div className='relative flex items-center justify-between'>
          <div className='flex items-center'>
            <ul className='flex items-center hidden space-x-8 lg:flex'>
              <li>
                <a
                  href='/'
                  aria-label='Inicio'
                  title='Inicio'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  INICIO
                </a>
              </li>
              <li>
                <a
                  href='#que_es'
                  aria-label='Que es'
                  title='Que es'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  ¿QUÉ ES?
                </a>
              </li>
              <li>
                <a
                  href='#cuando'
                  aria-label='Cuando'
                  title='Cuando'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  ¿CUÁNDO?
                </a>
              </li>
              <li>
                <a
                  href='#donde'
                  aria-label='Donde'
                  title='Donde'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  ¿DÓNDE?
                </a>
              </li>
              <li>
                <a
                  href='#agenda'
                  aria-label='Agenda'
                  title='Agenda'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  AGENDA
                </a>
              </li>
              <li>
                <a
                  href='#expositores'
                  aria-label='Expositores'
                  title='Expositores'
                  className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                >
                  EXPOSITORES
                </a>
              </li>
            </ul>
          </div>
          <ul className='flex items-center hidden space-x-8 lg:flex'>
            <li>
              <a
                  onClick={handleClick}
                href='/inscripciones'
                className='px-6 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-naranjo_rancagua hover:bg-celeste_rancagua rounded-lg font-bold text-xl'
                style={page === '/inscripciones' ? { display: 'none' } : {}}
              >
                INSCRÍBETE AQUÍ
              </a>
            </li>
          </ul>
          <div className='lg:hidden'>
            <button
              aria-label='Open Menu'
              title='Open Menu'
              className='p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50 hover:bg-celeste_rancagua'
              onClick={() => setIsMenuOpen(true)}
            >
              <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
                <path
                  fill='currentColor'
                  d='M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z'
                />
                <path
                  fill='currentColor'
                  d='M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z'
                />
                <path
                  fill='currentColor'
                  d='M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z'
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div className='absolute top-0 left-0 w-full z-51'>
                <div className='p-5 bg-white border rounded shadow-sm'>
                  <div className='flex items-center justify-between mb-4'>
                    <div>
                      <button
                        aria-label='Close Menu'
                        title='Close Menu'
                        className='p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline'
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
                          <path
                            fill='currentColor'
                            d='M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z'
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul className='space-y-4'>
                      <li>
                        <a
                          href='/'
                          aria-label='Inicio'
                          title='Inicio'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          INICIO
                        </a>
                      </li>
                      <li>
                        <a
                          href='#que_es'
                          aria-label='Que es'
                          title='Que es'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          ¿QUÉ ES?
                        </a>
                      </li>
                      <li>
                        <a
                          href='#cuando'
                          aria-label='Cuando'
                          title='Cuando'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          ¿CUÁNDO?
                        </a>
                      </li>
                      <li>
                        <a
                          href='#donde'
                          aria-label='Donde'
                          title='Donde'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          ¿DÓNDE?
                        </a>
                      </li>
                      <li>
                        <a
                          href='#agenda'
                          aria-label='Agenda'
                          title='Agenda'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          AGENDA
                        </a>
                      </li>
                      <li>
                        <a
                          href='#expositores'
                          aria-label='Expositores'
                          title='Expositores'
                          className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                        >
                          EXPOSITORES
                        </a>
                      </li>
                      <li>
                        <Button
                          className='px-6 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-naranjo_rancagua rounded-lg '
                          style={
                            page === '/inscripciones' ? { display: 'none' } : {}
                          }
                        >
                          <a
                            href='/inscripciones'
                            className='font-bold text-xl'
                          >
                            INSCRÍBETE AQUÍ
                          </a>
                        </Button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default NavbarUi
